import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { QuoteToolLiteStore } from '../store';

/**
 * Guard that handles navigation for the children path.
 * This guard checks if the current step in the store matches the route being accessed.
 * If it matches, navigation proceeds. If it doesn't match, it redirects to the correct step.
 *
 * @returns Observable<boolean | UrlTree> indicating if navigation should proceed or the route to redirect to
 */
export const currentStepGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<UrlTree | boolean> => {
  const qtLiteStore = inject(QuoteToolLiteStore);
  const router = inject(Router);

  return qtLiteStore.currentStepId$.pipe(
    map((routeId) => {
      if (routeId === route.firstChild?.routeConfig?.path) {
        return true;
      }
      return router.createUrlTree([routeId]);
    }),
  );
};
